/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Specifies the type of person associated with an investigation.
 */
export enum InvestigationTypePersonType {
    ALL = 'all',
    ANONYMOUS = 'anonymous',
    IDENTIFIED = 'identified',
}
